import { Component, Input, OnInit } from '@angular/core';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';
import { ModalService } from 'src/app/components/modals/modal.service';

@Component({
  selector: 'ai-chatbot',
  templateUrl: './ai-chatbot.component.html',
  styleUrl: './ai-chatbot.component.scss',
  standalone: false,
})
export class AiChatbotComponent implements OnInit {
  @Input() initialPrompt: string = '';

  selectedTemplateIdx: number | null = null;
  focusPromptInput: boolean = true;

  constructor(
    public aiChatbotService: AIChatbotService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    if (!this.aiChatbotService.currentSession()) {
      this.aiChatbotService.startNewSession();
    }
  }

  async restartSession(): Promise<void> {
    try {
      await this.modalService.confirm(
        'Start a New Chat?',
        'Starting a new chat will clear your current conversation. This action cannot be undone. Are you sure you want to continue?',
        'Start New Chat',
        'Cancel',
        'messageInput',
      );
    } catch (error) {
      return;
    }

    this.aiChatbotService.restartSession();
  }

  focusPromptBoxInput() {
    this.focusPromptInput = false;
    setTimeout(() => {
      this.focusPromptInput = true;
    });
  }
}
